import axios from "axios";
import * as moment from "moment";

import {
    AllowableSelfServiceCheckInIPAddress,
    CreateAllowableSelfServiceCheckInIPAddress,
    EmployeeSelfCheckInAppointmentClinicModel,
    EmployeeSelfCheckInSearchModel,
    EmployeeSelfCheckInSettingsModel
} from "./models";

const selfServiceCheckInUrl = "/api/selfServiceCheckIn";
const employeeSelfCheckInUrl = "/api/employeeSelfCheckIn";

const getAll = async () => (await axios.get<AllowableSelfServiceCheckInIPAddress[]>(selfServiceCheckInUrl)).data;

const get = async (id: string) => (await axios.get<AllowableSelfServiceCheckInIPAddress>(`${selfServiceCheckInUrl}/${id}`)).data;

const create = async (ipAddress: CreateAllowableSelfServiceCheckInIPAddress) =>
    (await axios.post<AllowableSelfServiceCheckInIPAddress>(selfServiceCheckInUrl, ipAddress)).data;

const update = async (ipAddress: AllowableSelfServiceCheckInIPAddress) =>
    (await axios.put<AllowableSelfServiceCheckInIPAddress>(`${selfServiceCheckInUrl}/${ipAddress.id}`, ipAddress)).data;

const getSettings = async () => (await axios.get<EmployeeSelfCheckInSettingsModel>(`${employeeSelfCheckInUrl}/settings`)).data;

const getAppointment = async (searchModel: EmployeeSelfCheckInSearchModel) => {
    const response = await axios.post<EmployeeSelfCheckInAppointmentClinicModel>(`${employeeSelfCheckInUrl}/appointment`, searchModel);
    const model = response.data;
    return {
        ...model,
        appointmentClinicStartTime: model.appointmentClinicStartTime && moment(model.appointmentClinicStartTime),
    };
};

export const SelfServiceCheckInApi = { getAll, get, create, update, getSettings, getAppointment };
